import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube, Mail, Phone, MessageCircle } from 'lucide-react';
import { socialLinks } from '../mockData';

const Footer = () => {
  return (
    <footer className="ucf-footer">
      <div className="footer-container">
        {/* Logo & Tagline */}
        <div className="footer-section">
          <img 
            src="https://customer-assets.emergentagent.com/job_8c6b9da3-c7cf-481c-ab7e-ed71573e5780/artifacts/3akixpjr_ucf.png" 
            alt="United Christian Fellowship" 
            className="footer-logo"
          />
          <p className="footer-tagline">
            Uniting Churches. Igniting Faith. Transforming Communities.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/im-new">I'm New</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/sermons">Sermons</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/leadership">Leadership</Link></li>
          </ul>
        </div>

        {/* Get Involved */}
        <div className="footer-section">
          <h3 className="footer-heading">Get Involved</h3>
          <ul className="footer-links">
            <li><Link to="/watch-live">Watch Live</Link></li>
            <li><Link to="/prayer-request">Prayer Request</Link></li>
            <li><Link to="/media">Media Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Stay Connected */}
        <div className="footer-section">
          <h3 className="footer-heading">Stay Connected</h3>
          <div className="social-links">
            <a 
              href={socialLinks.facebook} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="Facebook"
            >
              <Facebook size={20} />
              <span>Facebook</span>
            </a>
            <a 
              href={socialLinks.youtube} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="YouTube"
            >
              <Youtube size={20} />
              <span>YouTube</span>
            </a>
            <a 
              href={socialLinks.whatsapp} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link"
              aria-label="WhatsApp"
            >
              <MessageCircle size={20} />
              <span>WhatsApp</span>
            </a>
            <a 
              href={`mailto:${socialLinks.email}`} 
              className="social-link"
              aria-label="Email"
            >
              <Mail size={20} />
              <span>{socialLinks.email}</span>
            </a>
            <a 
              href={`tel:${socialLinks.phone}`} 
              className="social-link"
              aria-label="Phone"
            >
              <Phone size={20} />
              <span>{socialLinks.phone}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} United Christian Fellowship Edmonton. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
